// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"fad86951","322":"1d0afd0a","568":"1c8580e6","925":"c7a8c5ad"}[chunkId] + ".chunk.js";
};